import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  color: ${props => props.theme.palette.primary.alphaDark};
  padding: 18px 40px;
  min-height: 55vh;
  display: flex;
  flex-direction: column;

  h3 {
    font: ${font('default', 'medium', '32px/1.5')};
    margin: 0;
    ${bp('sm')`
      font: ${font('default', 'medium', '24px/1.2')};
    `}
  }

  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 35px;
  }

  > div {
    margin-top: auto;
  }
`

export const Item = styled.li`
  border: 1px solid ${props => props.theme.palette.general.greyLight};
  border-radius: 2px;
  background-color: ${props => props.theme.palette.general.light};
  padding: 14px 16px 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font: ${font('default', 'normal', '20px/1.2')};
  margin-top: 24px;
  cursor: pointer;
  ${bp('sm')`
    font: ${font('default', 'normal', '18px/1.2')};
  `}

  > p {
    max-width: 80%;
    margin: 0;

    strong {
      font-weight: ${props => props.theme.font.default.bold};
    }
  }

  > svg {
    width: 40px;
    height: 40px;
    fill: ${props => props.theme.palette.primary.alphaDark};
    ${bp('sm')`
      width: 25px;
      height: 25px;
    `}
  }
`
